import * as XLSX from 'xlsx';

import { CategoryItem } from '~/services/ExperiencesService';

export function generateCategoryTemplate(categories: CategoryItem[]): void {
  const workbook = XLSX.utils.book_new();

  const uploadRows = [
    { 'DEAL ID': 'offer-id-1', 'CATEGORY TAGS': '"Beaches & Islands","Outdoor Activities"', ACTION: 'add' },
    { 'DEAL ID': 'offer-id-2', 'CATEGORY TAGS': '"City Tours"', ACTION: 'remove' },
  ];
  const uploadSheet = XLSX.utils.json_to_sheet(uploadRows);
  XLSX.utils.book_append_sheet(workbook, uploadSheet, 'Upload');

  const categoryRows = (categories ?? []).map((c) => ({ ID: c.id, Label: c.label ?? c.value }));
  const categoriesSheet = XLSX.utils.json_to_sheet(categoryRows);
  XLSX.utils.book_append_sheet(workbook, categoriesSheet, 'Categories');

  XLSX.writeFile(workbook, 'bulk-category-update-template.xlsx');
}
